"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _utils = require('shared/store/utils');
var _helpers = require('shared/actions/helpers');














const getAccountActions = _utils.createAsyncActions('GetAccount')
const listMyAccountsActions = _utils.createAsyncActions('ListMyAccounts')
const listAccountPeopleActions = _utils.createAsyncActions('ListAccountPeople')
const grantAccountRoleActions = _utils.createAsyncActions('GrantAccountRole')
const revokeAccountRoleActions = _utils.createAsyncActions('RevokeAccountRole')
const removeFromAccountActions = _utils.createAsyncActions('RemoveFromAccount')
const getAccountSettingsActions = _utils.createAsyncActions('GetAccountSettings')
const saveAccountSettingsActions = _utils.createAsyncActions('SaveAccountSettings')
const createAccountOrgActions = _utils.createAsyncActions('CreateAccountOrg')
const getMemberRemovalImpactActions = _utils.createAsyncActions('GetMemberRemovalImpact')

 const actionCreators = {
  getAccountActions,
  listMyAccountsActions,
  listAccountPeopleActions,
  grantAccountRoleActions,
  revokeAccountRoleActions,
  removeFromAccountActions,
  getAccountSettingsActions,
  saveAccountSettingsActions,
  createAccountOrgActions,
  getMemberRemovalImpactActions,
}; exports.actionCreators = actionCreators

exports. default = {
  getAccount: (req) => _helpers.wsCommand('GetAccount', getAccountActions, req, null),
  listMyAccounts: () => _helpers.wsCommand('ListMyAccounts', listMyAccountsActions, {}, null),
  listAccountPeople: (req) =>
    _helpers.wsCommand('ListAccountPeople', listAccountPeopleActions, req, null),
  grantAccountRole: (req) =>
    _helpers.wsCommand('GrantAccountRole', grantAccountRoleActions, req, null),
  revokeAccountRole: (req) =>
    _helpers.wsCommand('RevokeAccountRole', revokeAccountRoleActions, req, null),
  removeFromAccount: (req) =>
    _helpers.wsCommand('RemoveFromAccount', removeFromAccountActions, req, null),
  getAccountSettings: (req) =>
    _helpers.wsCommand('GetAccountSettings', getAccountSettingsActions, req, null),
  saveAccountSettings: (req) =>
    _helpers.wsCommand('SaveAccountSettings', saveAccountSettingsActions, req, null),
  createAccountOrg: (req) =>
    _helpers.wsCommand('CreateAccountOrg', createAccountOrgActions, req, null),
  getMemberRemovalImpact: (req) =>
    _helpers.wsCommand('GetMemberRemovalImpact', getMemberRemovalImpactActions, req, null),
}
